import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomCollaborationService } from '../custom-collaboration.service';

@Component({
    selector: 'app-custom-procedures-tab',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './custom-procedures-tab.component.html',
    styleUrls: ['./custom-procedures-tab.component.scss'],
    standalone: false
})
export class CustomProceduresTabComponent implements OnInit, OnDestroy {
  collaborationData: any;
  orderDetailSubscription: Subscription;

  constructor(
    private readonly customCollaborationService: CustomCollaborationService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.customCollaborationService.getCollaborationDetails('BUSINESS');
    this.orderDetailSubscription =
      this.customCollaborationService.collaborationDetails$.subscribe((res) => {
        if (res !== false && res !== null && res.resourceMedia.length !== 0) {
          this.collaborationData = res.resourceMedia;
          this.cdr.detectChanges();
        }
      });
  }
  ngOnDestroy(): void {
    this.orderDetailSubscription?.unsubscribe();
  }
}
